import React from "react";
import { Row } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import Styles from "./Projects.module.css";
import { Helmet } from "react-helmet";

function Projects() {
  return (
    <Row className={Styles.ProjectsPage}>
      <Helmet>
        <title>My Projects - Matamando Kalilani</title>
        <meta name="description" content="My software development projects" />
        <link rel="canonical" href="https://mata.codes/projects#top" />
        <meta name="robots" content="index, follow" />
      </Helmet>{" "}
      <Row className={Styles.ComingSoonBox}>
        <h1 className={Styles.ComingSoonText}>Coming Soon</h1>
        <div
          style={{
            width: "max-content",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "22px",
          }}
        >
          <HashLink style={{ textDecoration: "none" }} smooth to="/#top">
            <div className={Styles.GoBackHomeBox}>
              <div
                className="contact-button"
                style={{ width: "max-content", marginLeft: "0px" }}
                onClick={() => {}}
              >
                <span class="material-icons">arrow_back_ios</span>
                <p
                  style={{
                    marginRight: "20px",
                    marginLeft: "5px",
                    fontSize: "18px",
                  }}
                >
                  Go Back Home
                </p>
              </div>
            </div>
          </HashLink>
        </div>
      </Row>
    </Row>
  );
}

export default Projects;
